// constants
import { API_TOKEN } from "../constants/auth";

// get token
export const getToken = () => {
  return window.localStorage.getItem(API_TOKEN) || false;
};

export const clearToken = () => {
  window.localStorage.removeItem(API_TOKEN);
};

// parse token
export const parseJWT = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
